<template>
  <div class="highlight-container referral-home-banner-height  px-4">
    <div class="highlight-wrapper pt-4">
      <div class="third-row-container">
        <div>{{ $t(`label.referralProgram`) }}</div>
      </div>
      <div v-if="!isLoggedIn">
        <div v-if="$vuetify.breakpoint.smAndDown" class="matches-box first_box_match" style="overflow-x:hidden;">
          <router-link :to="{ name: routeName.REFERRAL_SUMMARY }" style="cursor: pointer;">
            <img alt="referral" :src="`${mediaUrl}/referral/${language}/refer_mobile.webp`" class="referral_img" />
          </router-link>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box first_box_match" style="overflow-x:hidden;">
          <router-link :to="{ name: routeName.REFERRAL_SUMMARY }" style="cursor: pointer;">
            <img alt="referral" :src="`${mediaUrl}/referral/${language}/refer_desktop_new.webp`" class="referral_img" />
            <!--            <v-img alt="referral" :src="`${mediaUrl}/referral/${language}/refer_desktop.jpg`" :aspect-ratio="1440 / 463" class="referral_img" />-->
          </router-link>
        </div>
      </div>
      <div v-else>
        <div v-if="$vuetify.breakpoint.smAndDown" class="matches-box first_box_match" style="overflow-x:hidden;">
          <div class="referral_mobile" :style="`background-image: url('${mediaUrl}/referral/green_bg_mobile.jpg');background-position: center`">
            <img class="topRight-float" style="" :src="`${mediaUrl}/referral/referralIcon.png`" />
            <img class="bottomLeft-float" style="" :src="`${mediaUrl}/referral/tg_logo.png`" />
<!--            <v-img :src="`${mediaUrl}/referral/green_bg_mobile.jpg`" max-width="100vw" class="referral_mobile_img">-->
              <v-row class="referral_mobile_row no-gutters">
                <v-col cols="12" class="referral_msg_desc2 mb-5">
                  <span class="text-center text-uppercase" v-html="$t(`message.newReferralDesc1_mobile`)"></span>
                </v-col>
                <v-col cols="12" style="z-index:3;">
                  <v-row class="referral-code fill-height no-gutters">
                    <v-col cols="4" class="referral_code_col">
                      <vue-qr-code name="asd" v-if="overview.my_referral_code" class="referralQRCode" :text="share_url" :size="85"></vue-qr-code>
                    </v-col>
                    <v-col cols="8" class="referral_details_col">
                      <!--                    <v-row>-->
                      <!--                      <v-col cols="12">{{$t(`field.referralCode`)}}</v-col>-->
                      <!--                      <v-col cols="12">-->
                      <!--                        <v-text-field readonly v-model="overview.my_referral_code"></v-text-field>-->
                      <!--                      </v-col>-->
                      <!--                    </v-row>-->

                      <app-form-field small readonly :enabled-label="true" :label="$t(`field.referralCode`)" v-model="overview.my_referral_code"></app-form-field>
                      <app-form-field readonly :enabled-label="true" :label="$t(`label.todayCommission`)" v-model="overview.commission_balance"></app-form-field>
                      <v-row no-gutters>
                        <v-col cols="6">
                          <v-btn class="dialog-button   text-capitalize " @click="share()">
                            <v-icon class="" x-small>mdi-share-variant</v-icon>
                            {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}
                          </v-btn>
                        </v-col>

                        <v-col cols="6">
                          <v-btn class=" refeerral_report_btn" @click="routeToReferralReport">
                            {{ $t(`button.referralReport`) }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-img>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box first_box_match" style="overflow-x:hidden;">
          <!--          <p>desktop</p>-->
          <v-img :src="`${mediaUrl}/referral/green_bg_desktop.png`" class="referral_desktop_img">
            <v-row no-gutters class="fill-height justify-center">
              <img class="bottomLeft-float" style="" :src="`${mediaUrl}/referral/tg_logo.png`" />
              <img class="megePhone_desktop" style="" :src="`${mediaUrl}/referral/megaPhone.png`" />
              <img class="topRight-IGFloat" style="" :src="`${mediaUrl}/referral/ig.png`" />
              <v-col cols="6" class="referral_qr_desktop">
                <!--                <v-badge avatar-->
                <!--                         bordered-->
                <!--                         overlap-->
                <!--                         large-->
                <!--                         class="fill-height">-->
                <!--                  <template v-slot:badge>-->
                <!--                    <v-avatar>-->
                <!--                      <v-img  src="${mediaUrl}/referral/megaPhone.png"></v-img>-->
                <!--                    </v-avatar>-->
                <!--                  </template>-->
                <!--                </v-badge>-->
                <v-row class="referral-code fill-height no-gutters">
                  <!--                  <span style="position: absolute">abosulte text</span>-->
                  <v-col cols="6" class="referral_code_col">
                    <vue-qr-code name="asd" v-if="overview.my_referral_code" class="referralQRCode" :text="share_url" :size="185"></vue-qr-code>
                  </v-col>
                  <v-col cols="6" class="referral_details_col">
                    <!--                    <v-row>-->
                    <!--                      <v-col cols="12">{{$t(`field.referralCode`)}}</v-col>-->
                    <!--                      <v-col cols="12">-->
                    <!--                        <v-text-field readonly v-model="overview.my_referral_code"></v-text-field>-->
                    <!--                      </v-col>-->
                    <!--                    </v-row>-->
                    <app-form-field readonly :enabled-label="true" :label="$t(`field.referralCode`)" v-model="overview.my_referral_code">
                      <template v-slot:form-field-append>
                        <v-fade-transition leave-absolute>
                          <img width="24" height="24" :src="`${mediaUrl}/referral/copyBtn.png`" alt="" @click="referralCodeCopy" />
                        </v-fade-transition>
                      </template>
                    </app-form-field>
                    <app-form-field readonly :enabled-label="true" :label="$t(`label.todayCommission`)" v-model="overview.commission_balance"></app-form-field>
                    <v-btn class="dialog-button subtitle-1 full-width text-capitalize pa-2 mb-2" @click="share()">
                      <v-icon class="mr-2">mdi-share-variant</v-icon>
                      {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copy_ref`) }}
                    </v-btn>
                    <v-btn class="full-width refeerral_report_btn" @click="routeToReferralReport">
                      {{ $t(`button.referralReport`) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="5" class="referral_desc_desktop">
                <v-row class="referral_msg fill-height">
                  <img class="bottomRight-float" style="" :src="`${mediaUrl}/referral/fb.png`" />
                  <v-col cols="12" class="referral_msg_desc1 pb-0">
                    <img class="topRight-float" style="" :src="`${mediaUrl}/referral/referralIcon.png`" />
                    <span style="font-size: 1.7rem;">{{ $t(`message.newReferralDesc1_desktop`) }}</span>
                    <!--                    <br />-->
                    <!--                    <span style="" class="referral_msg_desc1_figure">{{-->
                    <!--                        $t(`message.newReferralDesc1Figure_desktop`)-->
                    <!--                      }}</span>-->
                  </v-col>
                  <v-col cols="12" class="pa-0 d-flex pl-3" style="height: 60px">
                    <img loading="lazy" class="nineFigues-img" :src="`${mediaUrl}/referral/425_${language}.png`" />
                    <span style="font-size: 1.9rem;">{{ $t(`message.upTo`) }}</span>
                  </v-col>
                  <v-col cols="12" class="referral_msg_desc2 py-0">
                    <v-row no-gutters style="line-height: 1.3;"><span v-html="$t(`message.newReferralTnc_desktop`)"></span></v-row>
                  </v-col>
                  <v-col cols="12" class="referral_msg_desc2 py-0">
                    <span class="desc2-span" v-html="$t(`message.newReferralDesc3_desktop`)"></span>
                  </v-col>
                  <!--                  <v-col cols="12" class="referral_msg_desc3 py-0"></v-col>-->
                  <!--                  <v-col cols="12" class="referral_msg_tnc py-0">-->
                  <!--                    &lt;!&ndash;                    <span v-html="$t(`message.referralTnc`)">{{ $t(`message.referralTnc`) }}</span>&ndash;&gt;-->
                  <!--                    <span v-html="$t(`message.newReferralTnc_desktop`)"></span>-->
                  <!--                    <br />-->
                  <!--                    <span v-html="$t(`message.newReferralTnc2_desktop`)"></span>-->
                  <!--                  </v-col>-->
                </v-row>
              </v-col>
            </v-row>
          </v-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uiHelper } from '@/util'
import { SHARED } from '@/constants/constants'
import { ROUTE_NAME } from '@/constants/route.constants'
import { REFERRAL_GET_OVERVIEW } from '@/store/referral.module'
import VueQrCode from 'vue-qrcode-component'

export default {
  name: 'ReferralHomeBanner',
  components: {
    VueQrCode
  },
  data: () => ({
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    language: uiHelper.getLanguage(),
    routeName: ROUTE_NAME,
    overview: {},
    share_url: ''
  }),
  created() {
    this.getMemberReferralOverview()
  },
  computed: {
    webShareApiSupported() {
      return navigator.share
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    referralOverview() {
      return this.$store.state.referral.overview
    }
  },
  watch: {
    isLoggedIn() {
      this.getMemberReferralOverview()
    },
    referralOverview() {
      this.overview = this.$store.state.referral.overview
      if (window.location.host.toLowerCase() === '16896kk332.com') {
        this.share_url = 'https://www.krikya-play.com' + '?refer_code=' + this.overview.my_referral_code
      }
      else if (window.location.host.toLowerCase() === 'ab8945621.com') {
        this.share_url = 'https://www.krikya-play.com' + '?refer_code=' + this.overview.my_referral_code
      } else {
        // If not, construct the share URL normally
        this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code
      }
    }
  },
  methods: {
    referralCodeCopy() {
      // console.log('referral code appendIcon CLICKED,refer code : '+ this.overview.my_referral_code)
      navigator.clipboard.writeText(this.overview.my_referral_code)
    },
    share() {
      const sharing = {
        title: 'Refer a friend now and earn commission',
        text: 'Your referral code is ' + this.overview.my_referral_code + '.Refer a friend now and earn commission now! ',
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    },
    getMemberReferralOverview() {
      if (this.isLoggedIn) {
        this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
      }
    },
    routeToReferralPage() {
      if (this.isLoggedIn) {
        this.$router.push({
          name: ROUTE_NAME.REFERRAL_SUMMARY
        })
      } else {
        this.$parent.openLoginDialog()
      }
    },
    routeToReferralReport() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_REPORT
      })
    }
  }
}
</script>

<style lang="scss">
$referralMobileHeight: 310px;
$referrlDesktopHeight: 350px;
$referralColPadding: 20px 20px;

.whiteBg {
  background-color: #ffffff;
}

.referral_mobile {
  max-height: $referralMobileHeight;
  max-width: 100vw;
  width: 100%;

  .topRight-float {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -2%;
    right: -1%;
    transform: rotate(-20deg);
    z-index: 2;
  }

  .bottomLeft-float {
    position: absolute;
    width: 75px;
    height: 75px;
    bottom: -6%;
    left: -6%;
    z-index: 2;
    -ms-transform: rotate(-9deg); /* IE 9 */
    transform: rotate(-9deg);
  }

  .referral_mobile_row {
    flex-direction: column;
    padding: 20px 20px 20px 20px;

    .referral_msg_desc2 {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f27703 !important;
      border-radius: 5px;
      min-height: 40px;
      color: #fff;
      padding: 5px;
      font-size: 14px;

      .black-highlight {
        color: #000;
        font-weight: bold;
      }
    }
  }

  .referral-code {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2256197478991597) 0%, rgba(255, 255, 255, 0.65) 35%, rgba(255, 255, 255, 0.853284) 100%);
    padding-left: 5px;
    height: 150px;

    .referral_code_col {
      //background-color: rgb(255, 255, 255, 0.2);
      display: flex;
      align-items: center;

      .referralQRCode {
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        background-color: #ffffff;
        padding: 5px;
      }

      .referralQRCode {
        img {
          //border: 0px;
          //padding: 6px 6px;
          //margin: 0px 3px;
        }
      }
    }

    .referral_details_col {
      padding-right: 15px;
      padding-top: 10px;
      padding-left: 5px;

      .v-btn:not(.v-btn--round).v-size--default {
        height: 28px !important;
      }

      .input-field-label {
        font-size: 11px !important;
      }

      .v-input__control {
        .v-input__slot {
          min-height: 30px;
          height: 30px;
        }

        .v-text-field__details {
          margin-bottom: 0px !important;

          .v-messages__message {
            font-size: 11px;
          }
        }
      }

      .v-text-field__details {
        height: 3px;
        min-height: 0px !important;
      }

      .dialog-button {
        width: 100%;
        padding: 0 7px;
        color: #ffffff;
        background-color: var(--v-secondary-base) !important;
        font-size: 0.6rem;
      }

      //background-color: rgb(255, 255, 255, 0.2);
      .refeerral_report_btn {
        width: 95%;
        padding: 0 5px 0 5px;
        margin-left: 5px;
        background-color: #001e23;
        color: #ffffff;
        font-size: 0.6rem;
        text-transform: capitalize;
      }
    }
  }
}

.referral_mobile_img {
  max-height: $referralMobileHeight;
  max-width: 100vw;
}

.referral_desktop_img {
  max-height: $referrlDesktopHeight;
}

//background: linear-gradient(90deg, rgba(255,255,255,0.2256197478991597) 0%, rgba(255,255,255,0.65) 35%, rgba(255,255,255,0.853284) 100%);
.referral_qr_desktop {
  background-color: transparent;
  padding: 25px 25px !important;
  display: flex;
  align-items: center;

  .referral-code {
    position: relative;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2256197478991597) 0%, rgba(255, 255, 255, 0.65) 35%, rgba(255, 255, 255, 0.853284) 100%);
    align-items: center;
    border-radius: 5px;
    min-height: 250px;

    .referral_code_col {
      //background-color: rgb(255, 255, 255, 0.2);
      .referralQRCode {
        display: flex;
        justify-content: center;
      }

      .referralQRCode > img {
        border: 0px;
        padding: 0px;
        margin: auto;
      }
    }

    .referral_details_col {
      padding-right: 15px;

      .dialog-button {
        color: #ffffff;
        background-color: var(--v-secondary-base) !important;
        width: 100%;
      }

      //background-color: rgb(255, 255, 255, 0.2);
      .refeerral_report_btn {
        text-transform: capitalize;
        background-color: #001e23;
        color: #ffffff;
      }
    }
  }
}

.megePhone_desktop {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 3%;
  left: 3%;
  transform: rotate(-25deg);
  -ms-transform: rotate(-25deg); /* IE 9 */
  z-index: 2;
}

.topRight-IGFloat {
  position: absolute;
  width: 75px;
  height: 75px;
  top: -9%;
  right: 30%;
  filter: blur(2px);
  //-ms-transform: rotate(-20deg); /* IE 9 */
  //transform: rotate(-20deg);
}

.bottomLeft-float {
  position: absolute;
  width: 75px;
  height: 75px;
  bottom: -6%;
  left: -2%;
  -ms-transform: rotate(-9deg); /* IE 9 */
  transform: rotate(-9deg);
}

.referral_desc_desktop {
  .referral_msg {
    padding: $referralColPadding;
    color: #ffffff;
    //align-content: space-evenly;
    position: relative;
    line-height: 2;

    .nineFigues-img {
      max-width: 280px;
      height: 60px;
    }

    .bottomRight-float {
      position: absolute;
      width: 75px;
      height: 75px;
      bottom: -10%;
      right: -11%;
      -ms-transform: rotate(-9deg); /* IE 9 */
      transform: rotate(-9deg);
    }

    .referral_msg_desc1 {
      position: relative;
      line-height: 2;
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: end;

      .topRight-float {
        position: absolute;
        width: 75px;
        height: 75px;
        top: -22%;
        right: -13%;
        -ms-transform: rotate(-20deg); /* IE 9 */
        transform: rotate(-20deg);
      }

      .referral_msg_desc1_figure {
        font-size: 2.5rem;
        //color: linear-gradient(101deg, rgba(224,150,19,1) 0%, rgba(214,144,21,1) 61%, rgba(213,198,98,1) 89%, rgba(210,167,44,1) 98%);
        //-webkit-linear-gradient(101deg, rgba(255,165,6,1) 0%, rgba(251,160,1,1) 61%, rgba(213,198,98,1) 89%, rgba(210,167,44,1) 98%);
        background: -webkit-linear-gradient(67deg, rgba(255, 165, 6, 1) 0%, rgba(251, 160, 1, 1) 61%, rgba(255, 165, 6, 1) 89%, rgb(249 119 12) 96%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .referral_msg_desc2 {
      display: flex;
      flex-direction: column;
      //align-items: center;
      //justify-content: left;
      //background-color: #f27703 !important;
      border-radius: 5px;
      min-height: 40px;
      color: #ffffff;
      font-size: 2.0rem;

      .desc2-span {
        display: flex;
        flex-direction: column;

        &::before {
          content: '';
          background: linear-gradient(101deg, #1d7002 0%, #00bd04 35%, #00bd04 70%, rgba(98, 213, 108, 0.5256477591) 84%, rgba(68, 210, 44, 0) 100%);
          width: 100%;
          height: 2px;
        }
      }

      .desc3-span {
        font-size: 1.5rem;
      }

      .desc3-highlight {
        color: #ffea00;
        transform: skewX(-15deg);
        display: inline-block;
      }
    }

    .green-bg-tnc {
      background-color: #ffea00;
      transform: skewX(-15deg);
      display: inline-block;
      padding: 0 10px;
      color: #000;
      font-weight: bold;
    }

    .referral_msg_desc3 {
    }

    .referral_msg_tnc {
      font-size: 0.85rem;
      filter: drop-shadow(0 0 0.85rem #3a3a3a);
    }
  }
}

.referral-home-banner-height {
  /*height: 500px;*/
}

//@media (max-width: 400px) {
//  .qrCode > img {
//    max-height: 95px !important;
//    max-width: 95px !important;
//  }
//}

@media screen and (min-width: 421px) and (max-width: 559px) {
  .referralQRCode > img {
    max-height: 115px !important;
    max-width: 115px !important;
    width: 115px !important;
    height: 115px !important;
  }

  .referral_code_col {
    justify-content: center;
  }
}

@media (max-width: 420px) {
  .referralQRCode > img {
    width: 85px !important;
    height: 85px !important;
  }
}

//
//@media (max-width: 432px) {
//  .qrCode > img {
//    max-height: 88px !important;
//    max-width: 88px !important;
//    width: 85px!important;
//    height: 85px!important;
//  }
//}

@media (max-width: 599px) {
  .referral-home-banner-height {
    /*height: 254px;*/
  }
}

.referral_img {
  height: auto;
  width: 100%;
  aspect-ratio: 1440/463;
}

@media (max-width: 959px) {
  .referral_img {
    //height: 400px;
    aspect-ratio: 180/107;
  }
}
</style>
